export default "__VITE_PUBLIC_ASSET__b6bd5e58__"